import React from "react";
import Image from "components/image";
import RichText from "components/rich-text";
import { isMobile } from "utils/device-detect";
import clsx from "clsx/lite";

const StackTextImage = ({ data }) => {
	const { content, image, mobileImage, fullWidthImage, imageSettings: { centerText, textBelow } } = data;
	const mobileView = isMobile();

	const containerClasses = `
    flex flex-col hd-screen-max-width justify-between md:px-10 lg:px-8 p-5 items-center
    ${textBelow ? "flex-col-reverse" : "flex-col"}
  `;

	const img = (mobileView && mobileImage) ? mobileImage : image;

	return (
		<div>
			<div className={containerClasses}>
				<div className={clsx("w-full", centerText && "text-center")}>
					<RichText value={content?.data} />
				</div>
				<div className={clsx("w-full", fullWidthImage && mobileView && "w-full-image -mx-5")}>
					<Image image={img} to={img.url} alt={img?.alt} className="mb-5 lg:mb-0 block opacity-100" />
				</div>
			</div>
		</div>
	);
};

export default StackTextImage;
